import React from 'react';
import { Form } from 'formik';
import { Box, Text } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import { Label } from '../Modal.styles';
import { filterDomain } from '../parsedHttp';
import { FormContainer } from './DataSources.styles';

const DataSourcesForm = ({
  defaultSchema,
  values,
  handleBlur,
  handleChange,
  setFieldValue,
  handleChangeWithError,
}) => {
  return (
    <FormContainer p={3}>
      <Form id="addDataSourceFormModal" style={{ width: '100%' }}>
        <Box mx="5px">
          {Object.entries(defaultSchema).map(([k, v], i) => (
            <Box pb={3} key={k}>
              <Label>
                <Text size="normal" color="primaryText">
                  {v.label}
                </Text>
              </Label>
              {k === 'device_search_subdomain' ? (
                <Box horizontal>
                  <InputText
                    grow
                    autoFocus={i === 0}
                    placeholder={v.placeholder}
                    shouldDisplayClearButton={false}
                    isSecureField={v.isSecure}
                    id={v.id}
                    name={v.id}
                    value={filterDomain(values[k])}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                  />
                  <Box horizontal justify="center" align="center" ml={2}>
                    <Text size="normal" color="primaryText">
                      {`.evidence.com`}
                    </Text>
                  </Box>
                </Box>
              ) : (
                <InputText
                  autoFocus={i === 0}
                  placeholder={v.placeholder}
                  shouldErrorTakeSpace
                  shouldDisplayClearButton={false}
                  isSecureField={v.isSecure}
                  id={v.id}
                  name={v.id}
                  value={values[k]}
                  onChange={e => handleChangeWithError(handleChange, e)}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
              )}
            </Box>
          ))}
        </Box>
      </Form>
    </FormContainer>
  );
};

export default DataSourcesForm;
